import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { firstValueFrom } from 'rxjs';

import { TwcBadgeType } from '@topcon/twc-angular';

import { LogService, ProcessFilter, ProcessService, ToastService } from '@mirage-projects/cw-commons';
import { CollageProcess } from '@mirage-projects/cw-models';

/** This component displays the last 10 process */
@Component({
    selector: 'cw-process-widget',
    templateUrl: './process-widget.component.html',
    styleUrls: ['./process-widget.component.scss'],
    standalone: false,
})
export class ProcessWidgetComponent implements OnInit {
    /** Shows the loader */
    isLoading = true;
    processList!: CollageProcess[];

    constructor(
        private router: Router,
        private processService: ProcessService,
        private toastService: ToastService,
        private logService: LogService
    ) { }

    ngOnInit(): void {
        this.initializeJobs();
    }

    navigateToJobs(): void {
        this.router.navigate(['/process']);
    }

    getStatusBadgeType(process: CollageProcess): TwcBadgeType | undefined {
        switch (process.status) {
            case 'RUNNING':
                return 'info';
            case 'FINISHED':
                return 'success';
            case 'FAILED':
                return 'error';
            default:
                break;
        }

        return undefined;
    }

    private async initializeJobs(): Promise<void> {
        const processFilter = new ProcessFilter();
        processFilter.offset = 0;
        processFilter.limit = 10;
        try {
            const collageProcessResponse = await firstValueFrom(this.processService.filter(processFilter));
            this.processList = collageProcessResponse.items;
        } catch (error: unknown) {
            this.logService.error('Error getting the process in Process Widget', error);
            this.toastService.error('JOBS.ERROR_GETTING_TASKS');
        } finally {
            this.isLoading = false;
        }
    }
}
